.filterCard {
  margin-bottom: 16px;
}
